import * as R from 'ramda';
import { shouldUpdate } from 'recompose';

export default shouldUpdate(R.complement(R.equals));



// WEBPACK FOOTER //
// ../../src/utils/pureDeepEqual.js